<div
  *ngIf="text"
  class="commentIcon"
  [cupcakePopover]="popover"
  (mousedown)="$event.stopPropagation()"
  (click)="$event.stopPropagation()"
>
  <i class="fa fa-comment"></i>
</div>
